import { h } from "./createElement";
import { __assign } from "tslib";
import ReactDOM from 'react-dom';
import { emptyFn, inject } from './helper';
export function showWithTransition(_a) {
    var Component = _a.Component, transitionDuration = _a.transitionDuration, autoClose = _a.autoClose, props = _a.props, forcedProps = _a.forcedProps, _b = _a.injectClosePropNames, injectClosePropNames = _b === void 0 ? [] : _b, _c = _a.deepInjectClose, deepInjectClose = _c === void 0 ? [] : _c, contexts = _a.contexts;
    var div = document.createElement('div');
    document.body.appendChild(div);
    var timer;
    var closed = false;
    injectClosePropNames.forEach(function (key) {
        overrideSingle(props, key);
    });
    deepInjectClose.forEach(function (_a) {
        var reference = _a[0], key = _a[1];
        if (Array.isArray(reference)) {
            reference.forEach(function (obj) { return overrideSingle(obj, key); });
            return;
        }
        overrideSingle(reference, key);
    });
    var currentProps = __assign(__assign(__assign({}, props), forcedProps), { visible: true });
    function overrideSingle(obj, key) {
        var originalValue = obj[key] || emptyFn;
        obj[key] = inject(originalValue, close);
    }
    function update(newProps) {
        if (closed) {
            return;
        }
        currentProps = __assign(__assign(__assign(__assign({}, currentProps), newProps), forcedProps), { visible: true });
        render(currentProps);
    }
    function close() {
        if (closed) {
            return;
        }
        closed = true;
        clearTimeout(timer);
        currentProps = __assign(__assign({}, currentProps), { visible: false });
        render(currentProps);
        setTimeout(function () {
            ReactDOM.unmountComponentAtNode(div);
            div.remove();
        }, transitionDuration + 20);
    }
    function render(props) {
        var element = (contexts === null || contexts === void 0 ? void 0 : contexts.length)
            ? composeContexts(contexts, h(Component, __assign({}, props)))
            : h(Component, __assign({}, props));
        ReactDOM.render(element, div);
    }
    render(currentProps);
    if (autoClose) {
        timer = setTimeout(close, props.duration || 2000);
    }
    return { update: update, close: close };
}
function composeContexts(contexts, children) {
    return contexts.reduce(function (child, _a) {
        var Provider = _a.provider, value = _a.value;
        return h(Provider, { value: value }, child);
    }, children);
}
